var _g, _path, _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 831,
    viewBox: "0 0 562 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8828_3492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.999 823L35.5 406L521.5 413.5L281.999 823Z",
    fill: "#62ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 277C558 429.983 433.983 554 281 554C128.017 554 4 429.983 4 277C4 124.017 128.017 0 281 0C433.983 0 558 124.017 558 277Z",
    fill: "#62ADEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.701 407.603L402.64 383.528C419.833 372.164 430.805 352.667 430.805 331.281C430.805 299.357 406.774 272.94 375.851 269.168V213.391H378.625C380.74 213.391 382.943 211.675 382.943 209.559V201.199C382.943 199.083 380.74 197.367 378.625 197.367H328.697C326.582 197.367 324.865 199.083 324.865 201.199V209.559C324.865 211.675 326.582 213.391 328.697 213.391H331.963V268.707H256.416V217.311C256.416 211.539 251.737 206.861 245.966 206.861H132.451C128.359 206.861 124.644 209.248 122.945 212.97C121.245 216.691 121.874 221.062 124.553 224.155L148.537 251.833V383.406C148.537 388.62 152.36 392.93 157.354 393.716C158.228 418.627 178.753 438.626 203.872 438.626C225.952 438.626 244.477 423.172 249.235 402.516H282.204C286.962 423.172 305.487 438.626 327.566 438.626C339.608 438.626 350.598 434.03 358.872 426.502H429.548C434.073 426.502 438.085 423.588 439.486 419.286C440.886 414.982 439.359 410.267 435.701 407.603ZM203.873 402.515H221.618C218.03 408.585 211.421 412.668 203.873 412.668C192.512 412.668 183.27 403.424 183.27 392.065C183.27 380.706 192.513 371.464 203.873 371.464C211.421 371.464 218.03 375.545 221.618 381.615H203.873C198.102 381.615 193.423 386.295 193.423 392.065C193.423 397.837 198.102 402.515 203.873 402.515ZM228.412 298.048H176.653V235.348H228.412V298.048ZM327.568 412.669C320.02 412.669 313.412 408.587 309.823 402.516H327.566C333.337 402.516 338.016 397.837 338.016 392.066C338.016 386.295 333.337 381.616 327.566 381.616H309.822C313.41 375.546 320.02 371.464 327.568 371.464C338.928 371.464 348.169 380.707 348.169 392.065C348.169 403.425 338.927 412.669 327.568 412.669Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.5,
    cy: 331.5,
    rx: 21.5,
    ry: 36.5,
    fill: "#62ADEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 158.5,
    r: 24.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.5,
    cy: 134.5,
    r: 24.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 143.5,
    r: 24.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 133.5,
    r: 24.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.5,
    cy: 119.5,
    r: 24.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 119.5,
    r: 24.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 101.5,
    r: 24.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 118.5,
    r: 24.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 119.5,
    r: 24.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8828_3492",
    x: 0,
    y: 0,
    width: 562,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8828_3492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8828_3492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.99c84183f4b4c48d7ca0fcbea110372e.svg";
export { ForwardRef as ReactComponent };